import React from 'react';
import styled from 'styled-components';
import type { HTMLAttributes } from 'react';
import type { IconProps } from './types';
import type { SizeType } from '../../util/types';
import StudentIcon from './Icon.student';
import { APP_THEME } from '../../styles/theme/styled/theme';
import { ICON_STUDENT_CHART } from '../../util/data-id';
import { getPixelInteger } from '../../util/styled';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'color'>;
interface Props extends HTMLProps, IconProps {
  studentsNum?: number;
  noBorder?: boolean;
}

/**
 * @deprecated
 */
const StudentChartIcon = React.forwardRef<Ref, Props>(({
  studentsNum = 3,
  color = 'primary',
  size = 'md',
  noBorder = false,
  ...other
}: Props, ref) => {
  return (
    <div ref={ref} {...other as HTMLProps}>
      <StudentChartIconStyled
        data-id={ICON_STUDENT_CHART}
        $size={size as SizeType | number}
        className={`grid items-center justify-items-center w-full${!noBorder ? ' border-b-2' : ''}`}
        style={{
          borderColor: 'currentColor',
          gridTemplateColumns: `repeat(${studentsNum}, minmax(0, 1fr))`,
        }}
      >
        {[ ...Array(studentsNum) ].map((element, index) => (
          <StudentIcon
            key={`studentIcon__${index}`}
            background={color}
            size={Number.isInteger(size) ?
              (size as number / studentsNum) :
              (getPixelInteger(APP_THEME.sizes[size as SizeType]) / studentsNum)
            }
          />
        ))}
      </StudentChartIconStyled>
    </div>
  );
});

const StudentChartIconStyled = styled('div')<{ $size: SizeType | number }>`
  width: ${(props) => (Number.isInteger(props.$size) ? `${props.$size}px` : props.theme.sizes[props.$size])};
  height: ${(props) => (Number.isInteger(props.$size) ? `calc(${props.$size}px / 2)` : `calc(${props.theme.sizes[props.$size]} / 2)`)};
`;

StudentChartIcon.displayName = 'StudentChartIcon';

export default StudentChartIcon;
